<script>
import mixin from "@/pages/inspection_reports/form-sections/mixin";
import Input from "@/pages/components/form/input-only/input.vue";
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";

export default {
  mixins: [mixin],
  components: {Input, MultipleRadios},
  emits: ['update:form'],
  mounted() {
    for (let name in this.group.values) {
      let config = this.group.values[name];
      this.checkInput(config, config.value);
    }
  },
  methods: {
    handleInput(config, name, value) {
      this.checkInput(config, value);

      this.$emit('update:form', {
        group: this.group.name,
        input: name,
        value: config.value,
      });
    },

    checkInput(config, value) {
      let testValue = config.testValue;
      let margin = testValue / 100 * 10;
      if (testValue <= 500) {
        margin = 50;
      }
      let difference = Math.abs(testValue - value).toFixed(0);
      config.difference = difference;
      config.valid = difference <= margin ? 'OK' : 'Fout';
    }
  }
};
</script>

<template>
  <div class="col-12">
    <Card class="h-100">
      <h2 class="card-title mb-3">{{ group.title }}</h2>

      <div class="form-group row">
        <div class="col-2 d-none d-md-block">Belasting (N)</div>
        <div class="col-6 col-md-4">Aanwijzing (N)</div>
        <div class="col-6 col-md-4">Verschil</div>
      </div>

      <template v-if="group.values" v-for="(config, name, index) in group.values" :key="name">
        <div class="form-group row mb-2">
          <div class="col-12 col-md-2">{{ config.label }}</div>
          <div class="col-6 col-md-4">
            <Input
                :id="group.name + 'inputLeft' + index"
                v-bind="$attrs"
                :name="name"
                v-model="config.value"
                @update:modelValue="handleInput(config, name, $event)"
                required
            />
          </div>
          <div class="col-6 col-md-4">
            <Input
                :id="group.name + 'inputRight' + index"
                v-bind="$attrs"
                :name="name + '_difference'"
                :model-value="config.difference"
                :value="config.difference"
                :readonly="true"
                :disabled="true"
                required
            />
          </div>
          <div class="col-12 col-md-2 mt-2 mt-md-0 d-flex justify-content-end">
            <MultipleRadios
                v-bind="$attrs"
                :name="name"
                :model-value="config.valid ?? 'Fout'"
                :disabled="true"
                :options="[
                  { label: 'OK', value: 'OK' },
                  { label: 'Fout', value: 'Fout' },
                ]"
            />
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>